import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import Toast from 'components/common/Toast';
import { routes } from 'config/route';
import { resp_services, resp_service_filter } from 'config/const/global';
import './App.css';
import { useGetServiceListMutation } from 'config/api/waV1_user';


function App() {

  const router = useRoutes(routes)
  const [getSList] = useGetServiceListMutation()

  useEffect(() => {
    getSList()
      .then(res => {
        let temp = {}
        if (res.data?.status == 200) {
          resp_services.value = res.data?.data?.services?.data
          res.data?.data?.services?.data?.map(i => {
            let str = i?.name.split('.')
            switch (str.length) {
              case 1:
                temp[str] = str
                break;
              case 2:
                temp[str[0]] = {
                  ...temp[str[0]],
                  [str[1]]: `${str[0]}.${str[1]}`
                }
                break;
              case 3:
                temp[str[0]] = {
                  ...temp[str[0]],
                  [str[1]]: {
                    ...temp[str[0]]?.[str[1]],
                    [str[2]]: `${str[0]}.${str[1]}.${str[2]}`
                  }
                }
                break;

              default:
                temp[str] = str
                break;
            }

          })
          resp_service_filter.value = temp
        }
      })
  }, [])

  return (
    <div className="container-fluid wrapper p-0 m-0">

      <Toast />

      {router}
    </div>
  );
}

export default App;
